import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calm',
  templateUrl: './calm.component.html',
  styleUrls: ['./calm.component.scss']
})
export class CalmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
